import {createSlice} from "@reduxjs/toolkit";
import {DATA_LIMIT} from "../../app/constants";

const pay = createSlice({
	name: "pay",
	initialState: {
		loading: false,
        error: null,
		filter:{
			page : 1,
			department : '',
			limit : DATA_LIMIT,
		},
        items: [],
		pagination : {
			page : 1,
			limit : DATA_LIMIT,
			total: 0
		}
	},
	reducers: {
		fetchData(state) {
			state.loading = true;
            state.error = null;
			return state;
		},
		fetchDataSuccess(state, action) {
			state.loading = false;
			state.items = action.payload.data;
			state.pagination = action.payload.pagination;
			state.error = null;
			return state;
		},
		fetchDataFailed(state, action) {
			state.loading = false;
			state.error = action.payload;
			return state;
		},
		add(state, action) {
			state.items.unshift(action.payload);
			return state;
		},
		update(state, action) {
			let objIndex = state.items.findIndex((item => item.id == action.payload.id));
			state.items[objIndex] = {...state.items[objIndex], ...action.payload};
			return state;
		},
		delete(state, action) {
			state.items = state.items.filter(function(item) {
				return item.id !== action.payload
			})
		},
		//Action search
		setFilter(state, action) {
			state.filter = action.payload;
			return state;
		},
	}
})
//Action
export const payActions = pay.actions;
//Reducers
export const payReducer = pay.reducer;
//Selectors
export const payItemsSelector = (state) => state.pay.items;
export const payLoadingSelector = (state) => state.pay.loading;
export const payErrorSelector = (state) => state.pay.error;
export const payFilterSelector = (state) => state.pay.filter;
export const payPaginationSelector = (state) => state.pay.pagination;